import { createContext } from "react";

export const AuthContext = createContext({
  isLoggedIn:         false,
  userId:             null,
  token:              null,
  role:               null,
  isPaid:             false,
  paidUntil:          null,
  login:              () => {},
  logout:             () => {},
  updateSubscription: () => {},
});
